import { hausbankFields, hausbankFieldsWithSectionString } from 'hausbank/inquiry/fields';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { fieldValidators } from 'modules/Inquiry/inquiryFieldValidation/customValidations';
import { validateFieldValidationMap, ValidateSectionFunction } from 'new/form/useValidateFields';

export const validateFinancingNeedSection: ValidateSectionFunction<InquiryType.hausbank> = (
  form,
  values,
  store,
  conditions,
) => {
  return validateFieldValidationMap({
    validationMap: financingNeedSectionValidationMap,
    form,
    values,
    conditions,
  });
};

const {
  investmentAmount,
  maintenanceReserve,
  wegContribution,
  constructionSubsidies,
  financingAmount,
  ownersMeetingDate,
} = hausbankFields.financingNeedPage.financingNeedSection;
const { sectionString: loanTermInYears } =
  hausbankFieldsWithSectionString.financingNeedPage.financingNeedSection.loanTermInYears;

export const financingNeedSectionValidationMap = {
  [investmentAmount]: fieldValidators.number().min(100000).required(),
  [maintenanceReserve]: fieldValidators.number(),
  [wegContribution]: fieldValidators.number(),
  [constructionSubsidies]: fieldValidators.number(),
  [financingAmount]: fieldValidators.number().min(100000),
  [loanTermInYears]: fieldValidators.arraySelect().minSelect(1).maxSelect(3),
  [ownersMeetingDate]: fieldValidators.date().required(),
};
